import { Carto } from '@workspaces/types'
import {
  getInstance as getAuth0ServiceInstance,
  getSharedPlanTokenCartoV3,
} from '@/auth/index'

export default class BrowserCartoAuthorizer implements Carto.CartoAuthorizer {
  getToken(): string {
    // Shared-plan mode installs no Auth0 plugin, so the auth instance does not
    // exist. The share token is the only credential available; return it before
    // touching the (undefined) instance.
    const sharedPlanToken = getSharedPlanTokenCartoV3()
    if (sharedPlanToken) {
      return sharedPlanToken
    }
    // token is defined here; the undefined path redirects to /login
    return getAuth0ServiceInstance().getAccessTokenCartoV3() as string
  }
}
